import type { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Header from '../../Header';
import { GuestPortalThemesTable } from '../../Tables/GuestPortalThemes';

export const GuestPortalThemes: FC = () => {
  return (
    <Container fluid className="reservation-list-container">
      <Header title="Guest Portal" />
      <GuestPortalThemesTable />
    </Container>
  );
};
